import { FC } from "react";
import { Button, ModalWrapper } from "../../../../../components";
import { ButtonToolbar } from "react-bootstrap";

type BuyMoreQuotaConfirmationModalProps = {
  show: boolean;
  onClose: () => void;
};

const BuyMoreQuotaConfirmationModal: FC<BuyMoreQuotaConfirmationModalProps> = ({
  show,
  onClose
}) => {
  return (
    <div>
      <ModalWrapper
        id="quota_increse_request_sent_modal"
        data-testid="quota_increse_request_sent_modal"
        show={show}
        title="Quota Increase Request Received"
        onHide={onClose}
        stackingModal
        size="sm"
      >
        <p className="mb-20">
          Your request for a quota increase has been received. A member of our
          Sales team will contact you soon.
        </p>
        <ButtonToolbar className="btn-toolbar--separator d-flex justify-content-end align-center">
          <Button variant="primary" onClick={onClose} useUpdatedStyles>
            Close
          </Button>
        </ButtonToolbar>
      </ModalWrapper>
    </div>
  );
};

export default BuyMoreQuotaConfirmationModal;
